import axios from 'axios'

const baseURL = process.env.VUE_APP_PRODUCT_SERVICE

export default {
  namespaced: true,
  state: {
    config: null
  },
  mutations: {
    setConfig (state, payload) {
      state.config = payload
    }
  },
  actions: {
    async getConfig ({ commit }) {
      const promise = axios.get(baseURL + '/api/config')

      promise.then(response => {
        commit('setConfig', response.data)
      })

      return promise
    }
  }
}
